import { ThemeEnum } from '../enums'

/**Описание настроек персонализации пользователя */
export class PersonalizationModel {
  /**Размер шрифта */
  FontSize: number = 16
  /**Тема */
  Theme: ThemeEnum = ThemeEnum.Light

  constructor(obj?: Partial<PersonalizationModel>) {
    if (obj) Object.assign(this, obj)
  }
}
